import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`If `}<inlineCode parentName="p">{`handler`}</inlineCode>{` is `}<inlineCode parentName="p">{`undefined`}</inlineCode>{`, the SDK does not expect anything from you.`}</p>
    <p>{`If `}<inlineCode parentName="p">{`handler`}</inlineCode>{` exists, you MUST call one of the functions of the handler.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { Primer } from '@primer-io/checkout-web'

Primer.createHeadless(clientToken, {
    onCheckoutComplete(...args) {
        console.log('onCheckoutComplete', ...args)
    },
    onCheckoutFail(error, data, handler) {
        if (!handler) {
            return
        }

        // Tells the SDK that it can proceed
        // Note: this does not show any error message
        return handler.showErrorMessage()
    },
})
`}</code></pre>
    <Group summary='Properties' mdxType="Group">
	<Item title='showErrorMessage' subtitle='() => void' mdxType="Item">
		Tells the SDK that the error has been properly handled by your application. This does not display any error message.
	</Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      